import Screen from 'components/BusinessLogic/ScreenTemplates/LoggedScreen';
import { useSelector } from 'react-redux';
import { useGetBannersQuery } from 'services/ecommerceApi';
import { sessionSelectors } from 'store/state/selectors';
import HomeNewLayout from './HomeNewLayout';

export default function Home() {
  const producerUrl = useSelector(sessionSelectors.getProducerUrl);
  const { data: banners } = useGetBannersQuery(producerUrl) ?? {};

  return <Screen content={<HomeNewLayout banners={banners} />} />;
}
